import React, { useEffect, useState } from "react";
import styles from "./HomeSecond.module.css";
import unitedKingdom from "../../assets/images/united kingdom.png";
import france from "../../assets/images/france.png";
import dubai from "../../assets/images/dubai.png";
import { MdExpandMore } from "react-icons/md";
import viewmore from "../../assets/images/viewmore.svg";
import { Link } from "react-router-dom";
import { countriesApi } from "../../config/countriesApi";

export default function HomeSecond(props) {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const countries = async () => {
      const countries = await countriesApi();

      if (countries.data) {
        setData(countries.data.data);
        setLoader(false);
      } else if (countries.error) {
        console.log(countries.error);
        setLoader(false);
      }
    };
    countries();
  }, []);

  data.length = 4;

  return (
    <div className={styles.main}>
      <div className={styles.whole}>
        <h1 className={styles.heading}>Top destinations</h1>
        <div className={styles.cards}>
          {loader ? (
            <div className={styles.loader}>
            <div className="spinner-border" role="status" style={{position: "relative"}}></div>
            </div>
          ) : (
            data.map((value, index) => (
              <div className={styles.card} key={index}>
                <img
                  src={value.cover_image}
                  alt="cover_image"
                  className={styles.cardImage}
                />
                <div className={styles.cardBottom}>
                  <h1 className={styles.cardBottomName}>
                    {value.display_name}
                  </h1>
                  <Link to={`/countries/${value.name}`}>
                    <h1 className={styles.cardBottomLearn}>
                      Learn More <MdExpandMore className={styles.left} />
                    </h1>
                  </Link>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <div className={styles.end}>
        <h2 className={styles.viewMore}>View More</h2>
        <Link to="/dashboard/plan-a-trip">
        <img src={viewmore} alt="View More" className={styles.view} />
        </Link>
      </div>
    </div>
  );
}
